import { render, staticRenderFns } from "./ScreensaverLogo.vue?vue&type=template&id=7b64f4ed&scoped=true"
import script from "./ScreensaverLogo.vue?vue&type=script&lang=js"
export * from "./ScreensaverLogo.vue?vue&type=script&lang=js"
import style0 from "./ScreensaverLogo.vue?vue&type=style&index=0&id=7b64f4ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b64f4ed",
  null
  
)

export default component.exports